import type { KioskFlowRepository } from '../data/kiosk-flow-repository';
import type { KioskFlowOperatorContext } from '../types/kiosk-flow-types';
import { assertOperator } from './flow-validation';

// Returns the JSON a publish would push, without pushing or recording anything (Preview JSON)
export class PreparePublishKioskFlowUseCase {
  constructor(private readonly repository: KioskFlowRepository) {}

  async execute(ctx: KioskFlowOperatorContext): Promise<string> {
    assertOperator(ctx);
    return this.repository.preparePublish(ctx);
  }
}
